import { defaultError } from "api/config";
import { SubscriptionsStatus } from "models/payments/subscriptions";
import { OneTimePurchaseStatus } from "models/payments/one-time-purchase";

export const postPaymentAPI = async (
	price: number,
	productName: string,
	quantity: number,
	businessProfile: {
		id: number;
		fullName: string;
	},
	redirectPath: string,
) => {
	return await fetch("/api/interaction/payments/checkout", {
		method: "POST",
		mode: "cors",
		cache: "no-cache",
		credentials: "same-origin",
		headers: {
			"Content-Type": "application/json",
		},
		redirect: "follow",
		referrerPolicy: "no-referrer",
		body: JSON.stringify({
			amount: price,
			name: productName,
			quantity,
			businessProfile,
			redirectPath,
		}),
	});
};

export const postBillingPortalAPI = async (
	idBusinessProfile: string,
	nameBusinessProfile: string,
	redirectPath: string,
) => {
	return await fetch("/api/interaction/payments/billing/portal", {
		method: "POST",
		mode: "cors",
		cache: "no-cache",
		credentials: "same-origin",
		headers: {
			"Content-Type": "application/json",
		},
		redirect: "follow",
		referrerPolicy: "no-referrer",
		body: JSON.stringify({
			idBusinessProfile,
			nameBusinessProfile,
			redirectPath,
		}),
	})
		.then((response) => response.json())
		.catch(() => defaultError());
};

export const postElearningSubscriptionsFromBusinessProfilesIds = async (
	businessProfilesIdList: string[] | number[],
	status: SubscriptionsStatus = "all",
) => {
	return await fetch("/api/interaction/payments/subscriptions/business-profiles/elearning", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			businessProfilesIdList,
			status,
		}),
	})
		.then((response) => response.json())
		.catch(() => defaultError());
};

export const postTalentSubscriptionsFromBusinessProfilesIds = async (
	businessProfilesIdList: string[] | number[],
	status: SubscriptionsStatus = "all",
) => {
	return await fetch("/api/interaction/payments/subscriptions/business-profiles/talent", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			businessProfilesIdList,
			status,
		}),
	})
		.then((response) => response.json())
		.catch(() => defaultError());
};

export const postChallengeOneTimePurchasesFromBusinessProfilesIds = async (
	businessProfilesIdList: string[] | number[],
	status: OneTimePurchaseStatus = "all",
) => {
	return await fetch("/api/interaction/payments/one-time-purchase/business-profiles/challenge", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			businessProfilesIdList,
			status,
		}),
	})
		.then((response) => response.json())
		.catch(() => defaultError());
};
